(function() {
  
  function initializeProductCards() {
    const bars = document.querySelectorAll('.card-options-bar:not(.card-options-bar--simple)');
    
    bars.forEach(bar => {
      // Skip if already initialized
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      
      const colorSwatches = bar.querySelectorAll('.card-color-swatch');

      // Auto-select first in-stock color
      const firstInStock = Array.from(colorSwatches).find(s => s.dataset.soldOut !== 'true');
      if (firstInStock && firstInStock !== colorSwatches[0]) {
        colorSwatches.forEach(s => s.classList.remove('active'));
        firstInStock.classList.add('active');
      }
      
      const sizeSelect = bar.querySelector('.card-option-select');
      const variantIdInput = bar.querySelector('.product-variant-id');
      const addToCartBtn = bar.querySelector('.card-add-to-cart');
      
      if (!variantIdInput || !addToCartBtn) return;
      
      // Find the product image
      const cardWrapper = bar.closest('.card-wrapper');
      const cardMedia = cardWrapper ? cardWrapper.querySelector('.card__media .media img') : null;
      
      // Get variant data WITH INVENTORY
      const variantOptions = Array.from(bar.querySelectorAll('.variant-option-data')).map(input => ({
        id: input.dataset.variantId,
        option1: input.dataset.option1,
        option2: input.dataset.option2 || '',
        option3: input.dataset.option3 || '',
        available: input.dataset.available === 'true',
        inventory: parseInt(input.dataset.inventory) || 0
      }));
      
      // Get variant images
      const variantImages = Array.from(bar.querySelectorAll('.variant-image-data')).map(input => ({
        id: input.dataset.variantId,
        src: input.dataset.imageSrc,
        srcset: input.dataset.imageSrcset
      }));
      
      // Normalize text to handle Unicode quote issues
      function normalizeText(text) {
        if (!text) return '';
        return text.replace(/["'"'""'']/g, '');
      }
      
      function updateVariant() {
        const hasColorSwatches = colorSwatches.length > 0;
        const selectedColor = hasColorSwatches 
          ? bar.querySelector('.card-color-swatch.active')?.dataset.color 
          : null;
        const selectedSize = sizeSelect ? normalizeText(sizeSelect.value) : null;
        
        let matchedVariant = null;
        
        for (let v of variantOptions) {
          const normalizedOption1 = normalizeText(v.option1);
          const normalizedOption2 = normalizeText(v.option2);
          
          let matches = false;
          
          if (hasColorSwatches && selectedSize) {
            // Color + Size product
            matches = v.option1 === selectedColor && normalizedOption2 === selectedSize;
          } else if (hasColorSwatches && !selectedSize) {
            // Color only product
            matches = v.option1 === selectedColor && v.option2 === '';
          } else if (!hasColorSwatches && selectedSize) {
            // Size only product
            matches = normalizedOption1 === selectedSize && v.option2 === '';
          } else {
            // No options (shouldn't happen in multi-variant)
            matches = true;
          }
          
          if (matches) {
            matchedVariant = v;
            break;
          }
        }
        
        if (matchedVariant) {
          // Update variant ID
          variantIdInput.value = matchedVariant.id;
          
          // Update image if available
          if (cardMedia) {
            const variantImage = variantImages.find(img => img.id === matchedVariant.id);
            if (variantImage) {
              let imgSrc = variantImage.src;
              let imgSrcset = variantImage.srcset;
              
              if (imgSrc && imgSrc.startsWith('//')) {
                imgSrc = 'https:' + imgSrc;
              }
              if (imgSrcset) {
                imgSrcset = imgSrcset.replace(/\/\//g, 'https://');
              }
              
              cardMedia.src = imgSrc;
              if (imgSrcset) {
                cardMedia.srcset = imgSrcset;
              }
            }
          }
          
          // UPDATE BUTTON BASED ON INVENTORY
          if (!matchedVariant.available || matchedVariant.inventory <= 0) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold out';
          } else {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to cart';
          }
        }
      }
      
      // Color swatch click handlers
      colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          colorSwatches.forEach(s => s.classList.remove('active'));
          this.classList.add('active');
          updateVariant();
        });
      });
      
// Size select change handler (find this existing code)
if (sizeSelect) {
  sizeSelect.addEventListener('change', function() {
    // Add pulse animation
    this.classList.add('size-selected');
    setTimeout(() => {
      this.classList.remove('size-selected');
    }, 1000);
    
    updateVariant(); // Your existing update function
  });
}
      
      // Initialize on load
      updateVariant();
    });
  }
  
  // Handle form submission
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    if (form.classList.contains('card-inline-form')) {
      e.preventDefault();
      e.stopPropagation();
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartLink = document.querySelector('.shop-sidebar__cart');
            if (cartLink) {
              cartLink.textContent = `Cart (${cart.item_count})`;
            }
            
            document.querySelectorAll('[data-cart-count]').forEach(counter => {
              counter.textContent = cart.item_count;
            });
          });
        
        const btn = form.querySelector('.card-add-to-cart');
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = '໒꒰ྀི 𖦹 ˕ × ꒱ྀིა';
          btn.classList.add('cart-added-success');
          
          setTimeout(() => {
            btn.classList.remove('cart-added-success');
            const bar = form.querySelector('.card-options-bar');
            const currentVariantId = form.querySelector('.product-variant-id').value;
            const variantInput = bar.querySelector(`.variant-option-data[data-variant-id="${currentVariantId}"]`);
            let inv = parseInt(variantInput?.dataset.inventory) || 0;
            if (inv <= 1) {
              btn.textContent = 'Sold out';
              btn.disabled = true;
              if (variantInput) variantInput.dataset.inventory = '0';
            } else {
              btn.textContent = originalText;
              if (variantInput) variantInput.dataset.inventory = (inv - 1).toString();
            }
          }, 2000);
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        const btn = form.querySelector('.card-add-to-cart');
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = 'Error - try again';
          setTimeout(() => {
            btn.textContent = originalText;
          }, 2000);
        }
      });
    }
  }, true);
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductCards);
  } else {
    initializeProductCards();
  }
  
  // RE-INITIALIZE WHEN PRODUCT GRID CHANGES (FILTER AJAX)
  const productGridObserver = new MutationObserver(() => {
    initializeProductCards();
  });
  
  // Watch the product grid container for changes
  const observeProductGrid = () => {
    const productGrid = document.querySelector('.collection-product-grid, #ProductGridContainer, [id^="product-grid"]');
    if (productGrid) {
      productGridObserver.observe(productGrid, { 
        childList: true, 
        subtree: true 
      });
    }
  };
  
  // Start observing after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductGrid);
  } else {
    observeProductGrid();
  }
  
})();


 